// extracted by mini-css-extract-plugin
export default {"Images__deleteButton":"styles_Images__deleteButton__mERd9","Images__image":"styles_Images__image__jmnEz"};